export function closeWindowListener(callback) {
  if (typeof callback !== 'function') return;
  window.addEventListener('beforeunload', callback);
  return () => window.removeEventListener('beforeunload', callback);
}
